import { useLanguage } from "../context/LanguageContext";

export function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-[#1A1F1C]/8 bg-[#F4F4F0]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-12 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="h-6 w-6 rounded-lg bg-[#1E3A2B] flex items-center justify-center">
              <span className="h-2 w-2 rounded-full bg-[#C27B2B]" />
            </span>
            <span className="font-heading font-bold text-sm text-[#1A1F1C]">Reach New Edge™</span>
          </div>
          <p className="mt-2 font-mono-label text-[10px] text-[#5B655F]">Powered by Learning Recovery OS™</p>
          <p className="mt-3 text-sm text-[#5B655F] max-w-md">{t("footer.note")}</p>
        </div>
        <div className="text-left sm:text-right">
          <p className="text-sm text-[#525B56]">A Felix Lancelot Studios Experience</p>
          <p className="mt-1 font-mono-label text-[10px] text-[#5B655F]">{t("footer.foundation")}</p>
        </div>
      </div>
    </footer>
  );
}
